import axios from 'axios';
import {INews} from "@/shared/model/news.model";

const baseApiUrl = 'api/admin/news';

export default class NewsService {
    public retrieve(page: number,itemPerPage: number, searchTerm: string): Promise<any> {
        let url = baseApiUrl;

        const params = new URLSearchParams();

        if (page != null) {
            params.append('page', page.toString());
        }
        if (searchTerm) {
            params.append('email', searchTerm);
        }
        if(itemPerPage) {
            params.append('size', itemPerPage.toString());
        }
        const queryString = params.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        return new Promise<any>((resolve, reject) => {
            axios
                .get(url)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public delete(id: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .delete(`${baseApiUrl}/${id}`)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public create(entity: INews): Promise<INews> {
        return new Promise<INews>((resolve, reject) => {
            axios
                .post(`${baseApiUrl}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public update(entity: INews): Promise<INews> {
        return new Promise<INews>((resolve, reject) => {
            axios
                .put(`${baseApiUrl}/${entity.publicId}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public find(id: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .get(`${baseApiUrl}/${id}`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
